module.exports = __webpack_public_path__ + "2b88d7d23846f25279c71cbd0894a6bb.svg";